<div class="panel" *ngIf="sku">
    <div class="panel_title">
        SKU Details
    </div>

    <div class="panel_devider"></div>

    <div class="panel-header">
        <div class="panel-header_image">
            <img class="panel-header_image-inner" [src]="sku.Image" alt="" />
        </div>
        <div class="panel-header_title" [matTooltip]="sku.Title">{{ sku.Title }}</div>

        <div class="panel-header_chips">
            <app-sku-chip [name]="'Sku'" [value]="sku.Sku"></app-sku-chip>
            <app-sku-chip [name]="'Asin'" [value]="sku.Asin"></app-sku-chip>
        </div>
    </div>

    <div class="section" *ngIf="sku">
        <div class="section_title">Demand</div>
        <div class="section_content">
            <div class="section_item">
                <div class="section_name">Total SKU demand</div>
                <div class="section_value">{{sku.Suggested  | number }}</div>
            </div>

            <div class="section_item" *ngIf="sku.SelectedQty">
                <div class="section_name">Total SKU adjustment</div>
                <div class="section_value">{{sku.SelectedQty  | number }}</div>
            </div>

            <div class="section_item">
                <div class="section_name">Season adjustment</div>
                <div class="section_value">{{ sku.SeasonAmount | number: "1.0-2" }}</div>
            </div>
        </div>
        <div class="section_summary section_summary">
            Total Demand: {{demandTotal | number}}
        </div>
    </div>
    
    <div class="section" *ngIf="sku">
        <div class="section_title">Stock</div>
        <div class="section_content">
            <div class="section_item">
                <div class="section_name">Deduct due to FBA</div>
                <div class="section_value">{{sku.FbaStockAfterLtUsage}}</div>
            </div>
        </div>
        <div class="section_summary section_summary">
            Total Stock: {{sku.TotalFbastock  | number }}
        </div>

        <div class="section_summary section_summary--blue">
            Total Suggestion: {{suggestionTotal  | number }}
        </div>
    </div>

    <div class="section">
        <div class="section_title"></div>
        <div class="section_content">

            <app-sku-fba-history-grid [asin]="sku.Asin" [title]="'In Stock Days == 30 Days, 0 Sold'" [account]="sku.Account" [stockType]="sku.FulfilmentType"></app-sku-fba-history-grid>

        </div>
    </div>

    <div class="section">
        <div class="section_title">Actual sales</div>
        <div class="section_content">

            <div class="mini-grid-wrapper">
                <ag-grid-angular style="width: 100%; height: 300px;" class="ag-theme-alpine-thin" [gridOptions]="salesGridOptions" [headerHeight]="30"
                [rowHeight]="30">
                </ag-grid-angular>
            </div>

        </div>
    </div>


</div>